var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPptFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2499 0H23.6232L34.9576 11.8141V34.7926C34.9576 37.6712 32.6287 40 29.7601 40H10.2499C7.37137 40 5.04254 37.6712 5.04254 34.7926V5.20738C5.04249 2.32883 7.37132 0 10.2499 0V0Z",
    fill: "#8EA4BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6132 0V11.7241H34.9576L23.6132 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3293 28.6157V21.3493H14.4178C15.1774 21.3493 15.7871 21.5592 16.2469 21.989C16.6966 22.4088 16.9265 22.9685 16.9265 23.6781C16.9265 24.3778 16.6966 24.9475 16.2469 25.3673C15.7871 25.7871 15.1774 25.997 14.4178 25.997H13.1784V28.6157H11.3293ZM13.1784 24.4178H14.2079C14.4878 24.4178 14.6977 24.3578 14.8576 24.2279C15.0075 24.0979 15.0775 23.908 15.0775 23.6781C15.0775 23.4383 15.0076 23.2584 14.8576 23.1284C14.6977 22.9985 14.4878 22.9285 14.2079 22.9285H13.1784V24.4178ZM17.7062 28.6157V21.3493H20.7946C21.5542 21.3493 22.1639 21.5592 22.6237 21.989C23.0835 22.4088 23.3034 22.9685 23.3034 23.6781C23.3034 24.3778 23.0835 24.9475 22.6237 25.3673C22.1639 25.7871 21.5542 25.997 20.7946 25.997H19.5652V28.6157H17.7062ZM19.5652 24.4178H20.5847C20.8646 24.4178 21.0845 24.3578 21.2344 24.2279C21.3843 24.0979 21.4643 23.908 21.4643 23.6781C21.4643 23.4383 21.3844 23.2584 21.2344 23.1284C21.0845 22.9985 20.8646 22.9285 20.5847 22.9285H19.5652V24.4178ZM25.972 28.6157V22.9285H23.9031V21.3493H29.9101V22.9285H27.8311V28.6157H25.972Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptFile);
export default __webpack_public_path__ + "static/media/ppt-file.dd2946b52c109459fbd94e542b7b9192.svg";
export { ForwardRef as ReactComponent };